export default __webpack_public_path__ + "static/media/Madhya-Kerala-Diocese.946f155f.png";